export enum InputStyle {
  DEFAULT = 'default',
  LOGIN = 'login',
  BORDERED = 'bordered',
  NONE = 'none',
}
